import { Row, Col, Form, Checkbox, Input, Select } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_relationshiplist_form } from "../../actions/form_slice";
import { debounce } from "lodash";
const { Option } = Select;
const RELATIONSHIPLIST = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector(
    (state) => state.form.relationshiplist_form_type
  );

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_relationshiplist_form(changedValues));
    onValuesChange(formData);
  }, 300);

  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="horizontal"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Row>
        <Col span={16} style={{ fontWeight: "bold" }}>
          Screen Name: RELATIONSHIP LIST (All Programs)
        </Col>
        <Col span={8}>
          <Form.Item
            name="Status"
            // label="Selected Status"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select defaultValue="Selected Status" style={{ width: 200 }}>
              <Option value="Selected Status">
                <strong>Selected Status</strong>
              </Option>
              <Option value="N/A">N/A</Option>
              <Option value="COMPLETE">COMPLETE</Option>
              <Option value="PENDING">PENDING</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <label>
        Are you a relative of the child/ren other than the parent? &nbsp;
        {
          <a
            href="https://content.dcf.ks.gov/ees/KEESM/Appendix/T-6RelationshipChart05-17.pdf"
            target="_blank"
            rel="noreferrer"
            style={{color: "Red", font: "1.2rem"}}
          >
            T-6 Relationship Chart
          </a>
        }
      </label>
      <Form.Item
        valuePropName="checked"
        name="Specify how relationship was determined for a caretaker TANF case?"
      >
        <Checkbox
          value="Specify how relationship was determined for a caretaker TANF case?
"
        >
          Specify how relationship was determined for a caretaker TANF case?
        </Checkbox>
      </Form.Item>
      <Row>
        <label>
          *VERIFY ALL RELATIONSHIPS HAVE BEEN ESTABLISHED AND ARE RECORDED
        </label>
      </Row>

      <Form.Item name="Comments" label="Comments">
        <Input style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item name="Pending for" label="Pending for:">
        <Input style={{ width: "100%" }} />
      </Form.Item>
    </Form>
  );
});
export default RELATIONSHIPLIST;
